import * as React from "react";
import { Component } from "react";
import styles from "../../styles/wizards/superadmin/AddBuildingTypeWizard.scss";
import autobind from "autobind-decorator";
import AddBuildingTypeIcon from "../../assets/images/add-building-type-64x64.svg";
import { mapStateToProps, setTableParams, validateForm } from "../../core/utils";
import { withRouter } from "react-router";
import { setNotification } from "../../redux/actions/general/notification";
import { createBuildingType, listBuildingTypes } from "../../redux/actions/table/superadmin/building_types";
import AddBuildingTypeForm from "../../forms/superadmin/add_building_types_wizard/AddBuildingTypeForm";

@withRouter
@mapStateToProps(state => ({
	table: state.table["superadmin_building_types"],
}))
class AddBuildingTypeWizard extends Component {
	@autobind
	_handleSubmit(formData) {
		const { edit } = formData;

		return validateForm(
			createBuildingType(formData).then(({ response }) => {
				listBuildingTypes().then(() => {
					if (edit) {
						setTableParams('superadmin_building_types', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('superadmin_building_types', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification("You have successfully added a new building type.");
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>Add building type</span>
						<span>Add building type to system building types</span>
					</div>
					<div className={styles.right}>
						<AddBuildingTypeIcon />
					</div>
				</div>
				<div className={styles.body}>
					<AddBuildingTypeForm onSubmit={this._handleSubmit} initialValues={{
						name: {},
					}} />
				</div>
			</>
		);
	}
}

export default AddBuildingTypeWizard;